export default __webpack_public_path__ + "assets/9b214b.svg";